"use client";

import styles from './androstenedione-modal.module.scss'

export default function HcpClinicalInformationAndrostenedioneModal({ index = 0}) {
  return (
    <section className={styles.container}>
      <div className={styles.content_wrapper}>
        <div className={styles.header}>
          <h2>CAH symptoms related to excess ACTH and <span className="text-nowrap">androgens<sup>15-21</sup></span></h2>
        </div>

        <div className={styles.symptoms_container}>
          <div className={`${styles.symptoms_list}`}>
            <ul>
              {index === 0 && <>
                <li>Early puberty</li>
                <li>Growth issues*</li>
              </>}
              <li>Fertility problems</li>
              <li>TARTs/OARTs</li>
              <li>Acne</li>
              <li>Hirsutism</li>
              <li>Hypertension*</li>
              <li>Hyperlipidemia*</li>
              <li>Obesity*</li>
              <li>Anxiety</li>
            </ul>
          </div>
        </div>

        <p className={styles.footnote}>
          OARTs=ovarian adrenal rest tumors; TARTs=testicular adrenal rest tumors.
        </p>

        <p className={styles.disclaimer}>
          These symptoms are listed for context and are not intended to 
          imply any clinical effect from CRENESSITY.
        </p>

        <ul className={`footnotes ${styles.footnote_reference}`}>
          <li><span className="hang">*</span><span>These impacts could also be related to high GC doses.</span></li>
        </ul>

        <div className={styles.indication}>
          <h3>INDICATION</h3>
          <p>
            CRENESSITY (crinecerfont) is indicated as adjunctive treatment to glucocorticoid replacement <span className="mobile:text-nowrap">to control androgens</span> in adults and pediatric patients 4 years of age and older with classic congenital <span className="text-nowrap">adrenal hyperplasia (CAH).</span>
          </p>
        </div>
      </div>
    </section>
  )
}
